import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import { themeColors } from 'src/theme';
import { Loader, P3, UserProfile } from 'src/components';
import { loadUser, loadUserUuid } from 'src/redux/user/actions';
import { selectUser, selectUserUuid } from 'src/redux/user/selectors';
import { useQueryParam } from 'src/hooks';

import { DashboardWrapper } from '../wrappers';

export default function UserProfileContainer() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { uuid = '' } = useParams();
  const [name] = useQueryParam('name', 'New User');
  const user = useSelector(selectUserUuid);
  const [isLoaderActive, setIsLoaderActive] = useState(user.uuid === uuid);
  const currUser = useSelector(selectUser);
  const isOwner = user.uuid === currUser.uuid;

  useEffect(() => {
    setIsLoaderActive(user.uuid !== uuid);
  }, [user]);

  useEffect(() => {
    dispatch(loadUser.init());
    if (uuid && uuid !== currUser.uuid) {
      dispatch(loadUserUuid.init({ uuid }));
    }
  }, [isOwner]);

  const approvalLabel = (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: { xs: 'center', sm: 'left' } }}>
      <Box
        sx={{
          width: '120px',
          height: '32px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: themeColors.lightYellow,
          borderRadius: '4px',
        }}
      >
        <P3>{t('common.waitingForApproval')}</P3>
      </Box>
    </Box>
  );

  return (
    <DashboardWrapper breadcrumbs={[['home'], [`${name}'s Profile`]]} navigationChildren={user?.step && user.step < 3 ? approvalLabel : null}>
      <Box component="main" sx={{ flexGrow: 1, overflow: 'auto' }}>
        {isLoaderActive ? <Loader /> : <UserProfile currUser={currUser} user={user} />}
      </Box>
    </DashboardWrapper>
  );
}
